"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupScopes = exports.Scopes = exports.Groups = void 0;
var Groups;
(function (Groups) {
    Groups["OWNER"] = "owner";
    Groups["ADMIN"] = "admin";
    Groups["USER"] = "user";
})(Groups = exports.Groups || (exports.Groups = {}));
var Scopes;
(function (Scopes) {
    // Organisation scopes
    Scopes["ORG_CREATE"] = "org:create";
    Scopes["ORG_LIST"] = "org:list";
    Scopes["ORG_READ"] = "org:read";
    Scopes["ORG_UPDATE"] = "org:update";
    Scopes["ORG_REMOVE"] = "org:remove";
    Scopes["ORG_STATS"] = "org:stats";
    // Destination scopes
    Scopes["DST_CREATE"] = "dst:create";
    Scopes["DST_LIST"] = "dst:list";
    Scopes["DST_READ"] = "dst:read";
    Scopes["DST_UPDATE"] = "dst:update";
    Scopes["DST_REMOVE"] = "dst:remove";
    Scopes["DST_STATS"] = "dst:stats";
    // Job scopes
    Scopes["JOB_CREATE"] = "job:create";
    Scopes["JOB_LIST"] = "job:list";
    Scopes["JOB_READ"] = "job:read";
    // User scopes
    Scopes["USR_CREATE"] = "usr:create";
    Scopes["USR_LIST"] = "usr:list";
    Scopes["USR_READ"] = "usr:read";
    Scopes["USR_UPDATE"] = "usr:update";
    Scopes["USR_REMOVE"] = "usr:remove";
    // Development
    Scopes["ALPHA"] = "dev:alpha";
    Scopes["BETA"] = "dev:beta";
})(Scopes = exports.Scopes || (exports.Scopes = {}));
const userFree = [
    Scopes.JOB_LIST,
    Scopes.JOB_READ,
    Scopes.DST_LIST,
    Scopes.DST_READ,
    Scopes.ORG_LIST,
    Scopes.ORG_READ,
    Scopes.DST_STATS,
    Scopes.ORG_STATS
];
const adminFree = [...userFree, Scopes.DST_UPDATE];
const ownerFree = [
    ...adminFree,
    Scopes.ORG_UPDATE,
    Scopes.DST_CREATE,
    Scopes.DST_REMOVE
];
const userStarter = [...userFree];
const adminStarter = [
    ...adminFree,
    ...userStarter,
    Scopes.USR_LIST,
    Scopes.USR_READ,
    Scopes.USR_CREATE,
    Scopes.USR_UPDATE,
    Scopes.USR_REMOVE
];
const ownerStarter = [
    ...ownerFree,
    ...adminStarter,
    Scopes.ORG_CREATE,
    Scopes.ORG_REMOVE
];
const userBasic = [...userStarter];
const adminBasic = [
    ...adminStarter,
    ...userBasic
];
const ownerBasic = [
    ...ownerStarter,
    ...adminBasic
];
const userPro = [...userBasic];
const adminPro = [
    ...adminBasic,
    ...userPro
];
const ownerPro = [
    ...ownerBasic,
    ...adminPro
];
const developer = [
    Scopes.ALPHA,
    Scopes.BETA
];
const tester = [
    Scopes.BETA
];
exports.groupScopes = {
    owner_free: ownerFree,
    admin_free: adminFree,
    user_free: adminFree,
    developer_free: developer,
    tester_free: tester,
    owner_starter: ownerStarter,
    admin_starter: adminStarter,
    user_starter: adminStarter,
    developer_starter: developer,
    tester_starter: tester,
    owner_basic: ownerBasic,
    admin_basic: adminBasic,
    user_basic: adminBasic,
    developer_basic: developer,
    tester_basic: tester,
    owner_pro: ownerPro,
    admin_pro: adminPro,
    user_pro: adminPro,
    developer_pro: developer,
    tester_pro: tester
};
